class SeoArticleEnhancer {
  constructor(root) {
    this.root = root;
    this.content = root.querySelector('[data-seo-article-content]');
    if (!this.content) return;
    this.addHeadingLinks();
  }

  slugify(text, index) {
    const slug = text.toLowerCase().trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return slug || `section-${index + 1}`;
  }

  addHeadingLinks() {
    const headings = [...this.content.querySelectorAll('h2, h3')];
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let id = heading.id || this.slugify(heading.textContent, index);
      let uniqueId = id;
      let suffix = 2;

      while (usedIds.has(uniqueId) || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
        uniqueId = `${id}-${suffix++}`;
      }

      heading.id = uniqueId;
      usedIds.add(uniqueId);
    });
  }
}

function initialiseSeoArticles(scope = document) {
  scope.querySelectorAll('[data-seo-article]').forEach((article) => {
    if (article.dataset.seoInitialised === 'true') return;
    article.dataset.seoInitialised = 'true';
    new SeoArticleEnhancer(article);
  });
}

document.addEventListener('DOMContentLoaded', () => initialiseSeoArticles());
document.addEventListener('shopify:section:load', (event) => initialiseSeoArticles(event.target));

(() => {
  const EXCLUDED_HEADINGS = [
    'frequently asked questions',
    'faqs',
    'related products',
    'related articles',
    'recommended products',
    'about the author',
    'need help',
    'get expert advice'
  ];

  const createSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const isExcluded = (heading) => {
    if (
      heading.closest(
        '.seo-article__cta, ' +
        '.seo-article__products, ' +
        '.seo-article__faqs, ' +
        '.seo-article__author, ' +
        '.seo-article__related, ' +
        '.sis-callout'
      )
    ) {
      return true;
    }

    const text = heading.textContent.trim().toLowerCase();

    return EXCLUDED_HEADINGS.some((excluded) => text === excluded);
  };

  const initialiseContents = (root = document) => {
    const placeholders = root.querySelectorAll(
      '.seo-article__content .sis-auto-contents:not([data-sis-initialised])'
    );

    placeholders.forEach((placeholder) => {
      placeholder.dataset.sisInitialised = 'true';

      const articleContent = placeholder.closest('.seo-article__content');

      if (!articleContent) {
        return;
      }

      const allHeadings = Array.from(
        articleContent.querySelectorAll('h2')
      );

      const headingsAfterPlaceholder = allHeadings.filter((heading) => {
        const position = placeholder.compareDocumentPosition(heading);

        return Boolean(position & Node.DOCUMENT_POSITION_FOLLOWING);
      });

      const headings = headingsAfterPlaceholder.filter(
        (heading) => !isExcluded(heading)
      );

      if (!headings.length) {
        placeholder.remove();
        return;
      }

      const usedIds = new Set();

      headings.forEach((heading) => {
        let baseId = heading.id || createSlug(heading.textContent);
        let uniqueId = baseId;
        let suffix = 2;

        while (
          usedIds.has(uniqueId) ||
          (document.getElementById(uniqueId) &&
            document.getElementById(uniqueId) !== heading)
        ) {
          uniqueId = `${baseId}-${suffix}`;
          suffix += 1;
        }

        heading.id = uniqueId;
        usedIds.add(uniqueId);
      });

      const nav = document.createElement('nav');
      nav.className = 'sis-contents';
      nav.setAttribute('aria-label', 'Article contents');

      const title = placeholder.dataset.title || 'Contents';

      nav.innerHTML = `
        <div class="sis-contents__inner">
          <h2 class="sis-contents__heading">${title}</h2>
          <ol class="sis-contents__list"></ol>
        </div>
      `;

      const list = nav.querySelector('.sis-contents__list');

      headings.forEach((heading) => {
        const item = document.createElement('li');
        item.className = 'sis-contents__item';

        const link = document.createElement('a');
        link.className = 'sis-contents__link';
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();

        item.appendChild(link);
        list.appendChild(item);
      });

      placeholder.replaceWith(nav);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialiseContents();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initialiseContents(event.target);
  });
})();